import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import "./LeadDetailStyle";
import LeadDetail from "components/agency/leadDetails";

const DashboardTable = React.memo((props) => {
  return (
    <>
      <LeadDetail />

    </>
  );
});

export default withRouter(DashboardTable);
